export default __webpack_public_path__ + "static/media/navigation.50dc14c0.mp4";